import { render, staticRenderFns } from "./g-regular.vue?vue&type=template&id=02c6f228&scoped=true&"
import script from "./g-regular.vue?vue&type=script&lang=js&"
export * from "./g-regular.vue?vue&type=script&lang=js&"
import style0 from "./g-regular.vue?vue&type=style&index=0&id=02c6f228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c6f228",
  null
  
)

export default component.exports